import * as React from "react";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

// util
import { ZonedMoment } from "@clockwise/client-commons/src/util/time-zone";
import { minutesPer } from "@clockwise/client-commons/src/constants/time-slot";

// styles
import { colors } from "@styles/color.styles";
import { simpleEvent as simpleEventStyle } from "@components/calendar/calendar-day-event/CalendarDayEvent.styles";

export interface FragmentedTimeRendererState {
  minStart: number;
  maxEnd: number;
}

export interface FragmentedTimePayload {
  startMillis: number;
  endMillis: number;
  className?: string;
}

const fragmentedTime: CSSProperties = {
  ...simpleEventStyle,
  zIndex: 1,
  background: `repeating-linear-gradient(-45deg, #ffffff, #ffffff 5px, ${colors.yellow.lightest} 5px, ${colors.yellow.lightest} 10px)`,
  border: "none",
};

export const fragmentedTimeStyles = {
  fragmentedTime,
};

/**
 * Generates angled yellow lines indicating fragmented time based on FragmentedTimePayload structure.
 *
 */
export const renderFragmentedTimeFactory = (mainClassName = "fragmentedTime") =>
  function renderFragmentedTime(
    this: React.Component<any, FragmentedTimeRendererState>,
    { startMillis, endMillis, className }: FragmentedTimePayload,
  ) {
    const { classes } = this.props;
    const { minStart, maxEnd } = this.state;

    const minMinutes = minStart * minutesPer;
    const maxMinutes = maxEnd * minutesPer;

    const startMoment = new ZonedMoment(startMillis);
    const endMoment = new ZonedMoment(endMillis);

    const startMinutes = startMoment.hours() * 60 + startMoment.minutes();
    const endMinutes = endMoment.hours() * 60 + endMoment.minutes();

    const top = `${((startMinutes - minMinutes) / (maxMinutes - minMinutes)) * 100}%`;

    const bottom = `${100 - ((endMinutes - minMinutes) / (maxMinutes - minMinutes)) * 100}%`;

    return (
      <div
        className={`${classes[mainClassName]}${className ? ` ${classes[className]}` : ""}`}
        style={{
          top,
          bottom: `calc(${bottom} + 2px)`,
          width: "calc(100% - 5px)",
        }}
      />
    );
  };
